import { render } from "./headmasterStudioState.vue?vue&type=template&id=a359ca86&scoped=true"
import script from "./headmasterStudioState.vue?vue&type=script&lang=js"
export * from "./headmasterStudioState.vue?vue&type=script&lang=js"

import "./headmasterStudioState.vue?vue&type=style&index=0&id=a359ca86&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a359ca86"]])

export default __exports__